<template>
  <v-app>
    <NavbarPublica />
    <section class="hero-section">
      <div class="px-2">
        <h1
          class="primary--text begin-therapy text-center mt-3"
          style="font-weight: 400"
        >
          {{ $t('home.textHomeTitle') }}
        </h1>
        <h2 class="subtitle-main">
          {{ $t('home.TextHomeSubTitle') }}
        </h2>
      </div>
      <div class="text-center mt-4">
        <v-col class="col-12 iframe-youtube">
          <iframe
            class="video-youtube"
            height="360"
            width="100%"
            src="https://www.youtube.com/embed/JA6zam2RKro"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-col>
        <section class="py-5 d-flex align-center section-busca-psy pt-1 px-2">
          <v-container pa-0>
            <v-row class="align-center justify-center justify-md-start ma-0">
              <v-col class="col-12 col-md-10 col-lg-9 col-xl-8">
                <h1
                  class="
                    primary--text
                    f-tituloSection
                    schedule-begin-therapy
                    text-left
                  "
                  style="font-weight: 400"
                >
                  {{ $t('home.TextHomeSearch') }}
                </h1>
                <router-link
                  :to="'/busca-psicologos'"
                  style="text-decoration: none"
                >
                  <div
                    class="
                      d-flex
                      flex-row
                      align-center
                      justify-center justify-md-start
                      mt-4 mt-lg-10
                      ml-xl-5
                    "
                  >
                    <div
                      style="background: #fff; font-style: italic"
                      class="
                        pseudo-input-busca-psy
                        card-box-shadow
                        pa-3
                        d-flex
                        align-center
                        primary--text
                        w-100
                      "
                    >
                      <v-icon
                        class="dark--text mr-3 d-none d-md-block"
                        size="40"
                        >search</v-icon
                      >Procure pelo profissional, motivo ou especialidade...
                    </div>
                    <v-btn
                      color="secondary"
                      class="
                        white--text
                        text-h6
                        weight-400
                        font-weight-medium
                        f-subtituloSection
                        text-transform-none
                        mt-4 mt-md-0
                        ml-3
                        br-10
                        px-7
                        d-none d-md-flex
                      "
                      style="min-height: 65px"
                      >PROCURAR</v-btn
                    >
                    <div
                      class="pseudo-input-busca-psy d-flex d-md-none pl-3"
                      style="
                        background-color: green;
                        border-radius: 0 10px 10px 0;
                      "
                    >
                      <v-icon class="white--text mr-3" size="20">search</v-icon>
                    </div>
                  </div>
                </router-link>
              </v-col>
            </v-row>
          </v-container>
        </section>
      </div>
      <div class="search-pisc pt-10">
        <img :src="require('../../assets/highres.svg')" />
        <h1 class="primary--text schedule-begin-therapy text-center mt-0 mb-4">
          {{ $t('home.TextHomeScheduling') }}
        </h1>
        <v-container>
          <v-row class="container-card mt-10 mb-5">
            <v-col class="p-5 justify-center box-card" style="z-index: 9">
              <div
                class="white white-box d-flex align-center row justify-center"
              >
                <v-icon class="primary--text" size="70">search</v-icon>
              </div>
              <p class="schedule-text text-center black--text mt-3">
                <strong class="font-size-title-grid"
                  >1.
                  <router-link
                    :to="'/busca-psicologos'"
                    style="text-decoration: none; color: #268bff"
                    >Procure</router-link
                  >
                  um psicólogo</strong
                >
                <br />
                <span class="subtitle-cards"
                  >Profissionais de todas as áreas</span
                >
              </p>
            </v-col>
            <v-col class="p-5 justify-center box-card" style="z-index: 9">
              <div
                class="white white-box d-flex align-center row justify-center"
              >
                <v-icon class="primary--text" size="70">calendar_today</v-icon>
              </div>
              <p class="schedule-text text-center black--text mt-3 mr-3">
                <strong class="font-size-title-grid"
                  >2. Agende sua consulta</strong
                >
                <br />
                <span class="subtitle-cards">{{
                  $t('home.subTextHomeCardScheduling')
                }}</span>
              </p>
            </v-col>
            <v-col class="p-5 justify-center box-card" style="z-index: 9">
              <div
                class="white white-box d-flex align-center row justify-center"
              >
                <v-icon class="primary--text" size="70">credit_card</v-icon>
              </div>
              <p class="schedule-text text-center black--text mt-4 mb-1">
                <strong class="font-size-title-grid">3. Pague online*</strong>
              </p>
              <p style="margin-bottom: 5px" class="text-center">
                <span class="subtitle-cards"> Comodamente e em segurança </span>
              </p>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <p class="subtitle-p text-center mb-12">
              *{{ $t('home.sunTextHomeScheduling') }}
            </p>
          </v-row>
        </v-container>
        <img :src="require('../../assets/highres.svg')" />
      </div>
    </section>

    <section class="section-2">
      <v-container fluid pa-0>
        <v-row class="ma-0">
          <v-col
            class="
              col-12
              card-search
              col-md-6
              d-flex
              align-end
              justify-center
              section-2-box
              s2-box1
              cover
              pa-0
            "
          >
            <div class="trasparent-background px-3">
              <v-row class="py-2 d-flex align-center justify-center">
                <v-col class="col-12 col-md-9 align-center text-center">
                  <div
                    class="white pa-1 d-flex align-center justify-center mb-6"
                  >
                    <strong>
                      <span class="headline font-weight-bold black--text mb-0"
                        >{{ $t('home.ondivanDivulgText') }}:
                      </span>
                    </strong>
                  </div>
                  <v-btn
                    to="/paciente/cadastro"
                    color="secondary"
                    large
                    class="primary--white"
                    >Criar Perfil</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col calss="col-12 col-md-6">
                  <p class="text-xs-center text-center black--text">
                    Confiança, segurança e apoio especializado no conforto do
                    seu lar.
                  </p>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col
            class="
              col-12
              card-search
              col-md-6
              d-flex
              align-end
              justify-center
              section-2-box
              s2-box2
              cover
              pa-0
            "
          >
            <div class="trasparent-background px-3">
              <v-row class="py-2 d-flex align-center justify-center">
                <v-col class="col-12 col-md-9 align-center text-center">
                  <div
                    class="white pa-1 d-flex align-center justify-center mb-6"
                  >
                    <strong>
                      <span class="headline font-weight-bold black--text mb-0"
                        >O parceiro do psicólogo.</span
                      >
                    </strong>
                  </div>
                  <v-btn
                    to="/psicologo/cadastro"
                    color="secondary"
                    large
                    class="primary--white"
                    >Criar Perfil</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col calss="col-12 col-md-6">
                  <p class="text-xs-center text-center black--text">
                    Otimize a gestão do seu consultório: agenda, finanças e
                    marketing.
                  </p>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section>
      <v-container fluid class="pa-0">
        <v-row class="align-center justify-center" style="padding-top: 20px">
          <div>
            <div class="px-3">
              <img
                :src="require('../../assets/icon_ondivan.png')"
                class="contain w-200"
              />
            </div>
          </div>
          <v-col
            class="
              col-12 col-lg-9
              mt-9
              align-center
              justify-center
              text-center
              ml-5
            "
          >
            <h1
              class="
                black--text
                therapy-online-title
                text-left
                .text-lg-h6
                title-med
              "
            >
              Atendimento Psicológico online
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-12 col-md-6">
            <v-row class="justify-center text-left">
              <v-col class="col-10 col-md-11 text-left">
                <p class="black--text why-text">
                  <strong>{{
                    $t('home.onlineAttendance.onlinePsiWhy')
                  }}</strong>
                  <br />
                </p>
                <p class="mb-0 black--text why-text mt-6 text-left">
                  {{ $t('home.onlineAttendance.paragraphOne') }}
                </p>
                <p class="mb-0 black--text why-text mt-3 text-left">
                  {{ $t('home.onlineAttendance.paragraphTwo') }}
                </p>
                <p class="mb-0 black--text why-text mt-3 text-left">
                  {{ $t('home.onlineAttendance.paragraphThree') }}
                </p>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col class="col-10 col-md-10" style="padding-top: 10px">
                <img
                  :src="require('../../assets/team.png')"
                  class="w-100 image-team fit-cover"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col class="col-12 col-md-6">
            <v-row class="justify-center text-1">
              <v-col class="col-10 col-md-20 mt-0">
                <p class="black--text why-text">
                  <strong>{{ $t('home.onlineAttendance.doesItWorks') }}</strong>
                  <br />
                </p>
                <p class="mb-0 black--text text-left why-text mt-3">
                  {{ $t('home.onlineAttendance.paragraphFour') }}
                </p>
                <p class="mb-0 black--text why-text mt-3">
                  {{ $t('home.onlineAttendance.paragraphFive') }}
                </p>
                <p class="mb-0 black--text why-text mt-3">
                  {{ $t('home.onlineAttendance.paragraphSix') }}
                </p>
                <p class="mb-0 black--text why-text mt-3">
                  {{ $t('home.onlineAttendance.paragraphSeven') }}
                </p>
                <div class="text-xs-center"></div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <v-container fluid class="card-cta-red">
        <img :src="require('../../assets/wave_home.svg')" class="wave" />
        <div class="card-content">
          <span>
            Fazer terapia pode ser exatamente aquilo que você precisa para
            aliviar as suas angústias.
          </span>
          <v-btn class="card-button" to="/busca-psicologos"
            >Encontre aqui o psicólogo para você!</v-btn
          >
        </div>
        <img :src="require('../../assets/wave_home.svg')" class="wave" />
      </v-container>
    </section>
    <section class="lightGray row-carousel-item" v-if="lang === 'pt'">
      <v-row class="justify-center align-center ma-0">
        <v-icon class="primary--text subtitle-hero mr-3">favorite</v-icon>
        <h2 class="black--text opinion-title news-text text-center my-3">
          {{ $t('home.clientTestimonials') }}
        </h2>
      </v-row>
      <v-carousel light height="auto" :interval="10000" class="pb-4">
        <v-carousel-item
          v-for="testimonial in testimonials"
          v-bind:key="testimonial.id"
          style="margin-bottom: 40px"
        >
          <v-row
            class="align-start justify-center ma-0"
            v-if="testimonial.video !== ''"
          >
            <v-col class="col-8 col-md-6">
              <div
                class="black--text text-center mb-5 mt-10 mb-11 video-container"
              >
                <iframe
                  :src="testimonial.video"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              <v-row class="justify-space-between pl-30 align-center">
                <div class="d-flex align-center">
                  <div class="text-center mr-5">
                    <img
                      :src="require('../../assets/account.svg')"
                      class="image-client fit-cover"
                    />
                  </div>
                  <div>
                    <span
                      class="black--text news-text text-center ml-1"
                      style="font-size: 23px"
                    >
                      {{ testimonial.title }}
                    </span>
                    <div class="text-center">
                      <v-icon
                        style="font-size: 2rem"
                        class="warning--text icon-star"
                        >star</v-icon
                      >
                      <v-icon
                        style="font-size: 2rem"
                        class="warning--text icon-star"
                        >star</v-icon
                      >
                      <v-icon
                        style="font-size: 2rem"
                        class="warning--text icon-star"
                        >star</v-icon
                      >
                      <v-icon
                        style="font-size: 2rem"
                        class="warning--text icon-star"
                        >star</v-icon
                      >
                      <v-icon
                        style="font-size: 2rem"
                        class="warning--text icon-star"
                        >star</v-icon
                      >
                    </div>
                  </div>
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="align-start justify-center ma-0" v-else>
            <v-col class="col-9 col-md-8" style="position: relative">
              <div class="text-center">
                <img :src="testimonial.avatar" class="image-client fit-cover" />
              </div>
              <div class="text-center">
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
              </div>
              <h2 class="black--text news-text text-center">
                {{ testimonial.title }}
              </h2>

              <div
                v-html="
                  testimonial.content && showFullText
                    ? testimonial.content
                    : testimonial.content.substring(0, 1000)
                "
                class="depoiment-content"
              ></div>

              <div
                v-if="testimonial.content && testimonial.content.length > 1000"
              >
                <div v-if="showFullText">
                  <div class="more-depoiments" @click="offMore()">
                    [Ver menos]
                  </div>
                </div>
                <div v-else>
                  <div class="more-depoiments" @click="onMore()">
                    [Ver mais]
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </section>

    <section class="section-midia px-2">
      <v-row class="align-center justify-center ma-0">
        <v-col class="col-12 col-md-6">
          <h1 class="black--text text-center f-subtituloSection">
            <v-icon class="secondary--text mr-3" size="70">track_changes</v-icon
            >{{ $t('home.ondivanMidiaText') }}
          </h1>
        </v-col>
      </v-row>

      <v-carousel
        class="carousel-entrevistas"
        cycle
        light
        height="auto"
        :interval="4000"
        style="padding-bottom: 40px"
      >
        <v-carousel-item>
          <v-row class="align-center justify-center ma-0">
            <v-col class="col-12 col-md-8 col-lg-6">
              <a
                target="blank"
                href="https://www.facebook.com/Jornal-O-Almonda-332193760539366/photos/1086842985074436"
                class="
                  text-decoration-none
                  black--text
                  text-center
                  lato-light-italic
                  f-subtituloSection
                  subtitulo-midia
                "
              >
                <u
                  >“Ondivan, projeto inovador na área da psicologia promove
                  consultas online. De Torres Novas para o mundo.”</u
                >
              </a>
              <div class="text-center mt-3">
                <a
                  target="blank"
                  href="https://maisribatejo.pt/2020/02/16/power-talk-o-caminho-emocional-do-empreendedor-na-startup-torres-novas/"
                >
                  <img
                    :src="require('../../assets/almoanda.png')"
                    style="width: 120px"
                  />
                </a>
              </div>
            </v-col>
          </v-row>
        </v-carousel-item>
        <v-carousel-item>
          <v-row class="align-center justify-center ma-0">
            <v-col class="col-12 col-md-8 col-lg-6">
              <a
                target="blank"
                href="https://mediotejo.net/torres-novas-inteligencia-emocional-para-empreendedores-na-startup"
                class="
                  text-decoration-none
                  black--text
                  text-center
                  lato-light-italic
                  f-subtituloSection
                  subtitulo-midia
                "
              >
                <u
                  >“O trabalho de Inês Mata tem como objetivo capacitar melhor
                  os participantes para os diversos desafios, com foco no
                  autoconhecimento e no controlo das emoções.”</u
                >
              </a>
              <div class="text-center mt-3">
                <a
                  target="blank"
                  href="https://mediotejo.net/torres-novas-inteligencia-emocional-para-empreendedores-na-startup"
                >
                  <img
                    :src="require('../../assets/logo-mediotejo.png')"
                    style="width: 150px"
                  />
                </a>
              </div>
            </v-col>
          </v-row>
        </v-carousel-item>
        <v-carousel-item>
          <v-row class="align-center justify-center ma-0">
            <v-col class="col-12 col-md-8 col-lg-6">
              <a
                target="blank"
                href="https://radiohertz.pt/torres-novas-como-utilizar-a-inteligencia-emocional-a-favor-dos-sonhos/"
                class="
                  text-decoration-none
                  black--text
                  text-center
                  lato-light-italic
                  f-subtituloSection
                  subtitulo-midia
                "
              >
                <u
                  >“As Power Talks com a Psicóloga Psicanalista Inês Mata são
                  mais do que conversas: são espaços que têm como objetivo
                  capacitar melhor os participantes para os diversos desafios,
                  com foco no autoconhecimento e no controlo das emoções.”</u
                >
              </a>
              <div class="text-center mt-3">
                <a
                  target="blank"
                  href="https://radiohertz.pt/torres-novas-como-utilizar-a-inteligencia-emocional-a-favor-dos-sonhos/"
                >
                  <img
                    :src="require('../../assets/logo-radio-hertz.png')"
                    style="width: 120px"
                  />
                </a>
              </div>
            </v-col>
          </v-row>
        </v-carousel-item>
        <v-carousel-item>
          <v-row class="align-center justify-center ma-0">
            <v-col class="col-12 col-md-8 col-lg-6">
              <a
                target="blank"
                href="https://maisribatejo.pt/2020/02/16/power-talk-o-caminho-emocional-do-empreendedor-na-startup-torres-novas/"
                class="
                  text-decoration-none
                  black--text
                  text-center
                  lato-light-italic
                  f-subtituloSection
                  subtitulo-midia
                "
              >
                <u
                  >“O caminho emocional do empreendedor: como utilizar a
                  inteligência emocional a favor dos sonhos” é o tema da
                  palestra (power talks), com a psicóloga e psicanalista Inês
                  Mata.”</u
                >
              </a>
              <div class="text-center mt-3">
                <a
                  target="blank"
                  href="https://maisribatejo.pt/2020/02/16/power-talk-o-caminho-emocional-do-empreendedor-na-startup-torres-novas/"
                >
                  <img
                    :src="require('../../assets/logo-maisribatejo.png')"
                    style="width: 120px"
                  />
                </a>
              </div>
            </v-col>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </section>

    <section>
      <v-container fluid class="card-cta-white">
        <img :src="require('../../assets/wave_home_red.svg')" class="wave" />
        <div class="card-content">
          <span>
            O ondivan está crescendo e trazendo mais conteúdos para você!
          </span>
          <v-btn class="card-button" to="/paciente/dashboard"
            >Crie o seu perfil e receba as novidades!</v-btn
          >
        </div>
        <img :src="require('../../assets/wave_home_red.svg')" class="wave" />
      </v-container>
    </section>
    <section class="bg-white">
      <v-row class="align-center justify-center ma-0">
        <v-col
          class="
            col-3
            offset-1
            col-md-1
            offset-md-3
            d-flex
            align-center
            justify-end
          "
        >
          <v-icon class="primary--text" size="60">email</v-icon>
        </v-col>
        <v-col class="col-6 col-md-5 align-center justify-md-center">
          <h1 class="primary--text therapy-online-title">Newsletter</h1>
        </v-col>
      </v-row>
      <p class="mb-0 text-center primary--text news-text px-2">
        Acompanhe as nossas novidades! Inscreva-se aqui!
      </p>
      <v-row class="row align-center justify-center ma-0">
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 20px 0px;
          "
        >
          <v-radio-group
            class="justify-center"
            row
            style="overflow: hidden"
            v-model="radioValue"
            :mandatory="true"
          >
            <v-radio
              value="paciente"
              label="Paciente"
              color="primary"
            ></v-radio>
            <v-radio
              value="psicologo"
              label="Psicólogo"
              color="primary"
            ></v-radio>
          </v-radio-group>
        </div>
      </v-row>
      <v-row class="column px-3 ma-0 justify-center">
        <v-col class="col-12 col-md-12 justify-center">
          <v-row class="justify-center align-center">
            <v-col class="col-10 col-sm-6 col-md-3">
              <v-text-field
                hide-details
                solo
                flat
                v-model="email"
                label="Seu email"
                background-color="#F7F7F7"
              ></v-text-field>
            </v-col>
            <v-col class="col-auto text-center text-md-start pl-md-0">
              <v-btn
                color="secondary"
                class="primary--white"
                :loading="isLoading"
                @click="signUp"
                >Enviar</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-10 col-md-4">
          <v-alert v-model="isAlert" :value="true" :type="isType" dismissible>{{
            msg
          }}</v-alert>
        </v-col>
      </v-row>
    </section>

    <section class="section-parceiros">
      <v-row class="align-center justify-center ma-0 mt-7">
        <v-col
          class="
            col-3
            offset-1
            col-md-1
            offset-md-3
            d-flex
            align-center
            justify-end
          "
        >
          <!-- <v-icon class="primary--text" size="60">thumb_up</v-icon> -->
          <v-img
            :src="require('../../assets/parceiros_icon.svg')"
            contain
            height="100px"
            width="100px"
          ></v-img>
        </v-col>
        <v-col class="col-6 col-md-5 align-center justify-md-center">
          <h1 class="primary--text therapy-online-title">Parceiros</h1>
        </v-col>
      </v-row>
      <h1
        class="
          primary--text
          therapy-online-subtitle
          parceiro-subtitle
          text-md-center
        "
      >
        PORQUÊ ser parceiro do Ondivan ?
      </h1>
      <v-row class="justify-center ma-0">
        <v-col class="col-12 col-lg-7">
          <p class="ma-0 gray--text text-center f-textoCorpoSection">
            O Ondivan acredita que juntos somos mais fortes, por isso, assinamos
            /estabelecemos acordos e protocolos com diversas instituições. Além
            disto, contamos com o apoio de entidades parceiras com o objetivo de
            prestar serviços de excelência aos nossos clientes.
            <br />Faça parte da nossa rede!
          </p>
        </v-col>
      </v-row>

      <v-row class="align-center justify-center ma-0">
        <v-col class="col-12 col-md-10 col-xl-7">
          <div
            class="
              d-flex
              flex-column flex-md-row
              align-center align-md-start
              justify-space-around
            "
          >
            <div
              class="
                d-flex
                flex-column
                align-center
                justify-end
                text-center
                mt-5 mt-md-0
              "
            >
              <a
                target="_blank"
                href="http://startuptorresnovas.pt/index.php/pt-pt/"
                class="black--text text-decoration-none"
              >
                <img
                  :src="require('../../assets/parceiro2.png')"
                  class="mx-lg-10"
                  style="width: 250px; height: 150px; object-fit: contain"
                />
                <h2 class="ma-0 mt-3">STARTUP TORRES NOVAS</h2>
              </a>
            </div>

            <div
              class="
                d-flex
                flex-column
                align-center
                justify-end
                text-center
                mt-5 mt-md-0
              "
            >
              <a
                target="_blank"
                href="httpS://www.klutch.com.br"
                class="black--text text-decoration-none"
              >
                <img
                  :src="require('../../assets/parceiro3.png')"
                  style="width: 180px; height: 150px; object-fit: contain"
                />
                <h2 class="ma-0 mt-3">KLUTCH TECNOLOGIA</h2>
              </a>
            </div>
          </div>

          <div
            class="
              d-flex
              flex-column flex-md-row
              align-center align-md-start
              justify-space-around
              mt-5 mt-md-10
            "
          >
            <div
              class="d-flex flex-column align-center justify-end text-center"
            >
              <a
                target="_blank"
                href="https://nersant.pt/"
                class="black--text text-decoration-none"
              >
                <img
                  :src="require('../../assets/parceiro4.png')"
                  style="width: 250px; height: 150px; object-fit: contain"
                />
                <h2 class="ma-0 mt-3">NERSANT</h2>
              </a>
            </div>

            <div
              class="
                d-flex
                flex-column
                align-center
                justify-end
                text-center
                mt-5 mt-md-0
              "
            >
              <a
                target="_blank"
                href="http://bombeirostorresnovas.pt/"
                class="black--text text-decoration-none"
              >
                <img
                  :src="require('../../assets/parceiro5.png')"
                  class="mx-lg-10"
                  style="width: 250px; height: 150px; object-fit: contain"
                />
                <h2 class="ma-0 mt-3">
                  BOMBEIROS VOLUNTÁRIOS
                  <br />TORREJANOS
                </h2>
              </a>
            </div>

            <div
              class="
                d-flex
                flex-column
                align-center
                justify-end
                text-center
                mt-5 mt-md-0
              "
            >
              <a
                target="_blank"
                href="https://lmfc.pt"
                class="black--text text-decoration-none"
              >
                <img
                  :src="require('../../assets/parceiro6.png')"
                  style="width: 250px; height: 150px; object-fit: contain"
                />
                <h2 class="ma-0 mt-3">
                  LARANJA MECÂNICA
                  <br />FUTSAL CLUBE
                </h2>
              </a>
            </div>
          </div>
        </v-col>
      </v-row>

      <div class="text-center mt-5 mb-10">
        <v-btn
          to="/parceiros"
          color="primary"
          class="
            lato-black
            white--text
            f-subtituloSection
            text-transform-none
            br-10
            px-9
          "
          style="min-height: 60px"
          >Saiba Mais</v-btn
        >
      </div>
    </section>

    <v-footer height="auto" color="primary">
      <v-row class="align-center justify-center ma-0">
        <v-col
          class="py-3 text-center white--text col-12 col-md-2"
          style="font-size: 12px"
        >
          <img
            :src="require('../../assets/ondivan_marca_white_slogan.svg')"
            width="180px;"
          />
        </v-col>
        <v-col
          class="py-3 text-center white--text col-12 col-md-2"
          style="font-size: 14px"
        >
          <strong>RESPONSÁVEL TÉCNICO:</strong>
          <br />Inês Mata {{ $t('footer.opp') }}
        </v-col>
        <v-col
          class="
            py-3
            d-flex
            flex-column
            text-center
            align-center
            justify-space-around
            col-12 col-md-2
          "
          style="font-size: 14px"
        >
          <div>
            <v-btn to="/faq" class="btn-faq">Faq</v-btn>
          </div>
          <div v-if="lang === 'pt'">
            <a
              href="https://www.livroreclamacoes.pt/"
              target="_blank"
              class="white--text"
              >Livro de Reclamações</a
            >
          </div>
          <div>
            <a href="/privacidade" class="white--text"
              >Política de privacidade</a
            >
          </div>
          <div>
            <a href="/termo" class="white--text">Termosde uso</a>
          </div>
        </v-col>
        <v-col class="py-3 text-center col-12 col-md-2" style="font-size: 14px">
          <a target="blank" href="https://fb.me/ondivan.net">
            <img
              :src="require('../../assets/facebook_icon.png')"
              width="40px;"
            />
          </a>
          <a target="blank" href="https://www.instagram.com/on.divan/">
            <img
              :src="require('../../assets/instagram_icon.png')"
              width="40px;"
              class="ml-4"
            />
          </a>
        </v-col>
        <v-col
          class="pa-3 row text-center col-12 col-md-2 align-center d-flex"
          style="font-size: 12px"
        >
          <div class="d-flex row align-center justify-center">
            <div>
              <p
                class="mb-1 mr-1 white--text"
                style="font-size: 1.2rem; display: flex; align-items: center"
              >
                <strong>Pagamentos:</strong>
                <a
                  href="https://stripe.com/pt-br-pt"
                  style="
                    padding: 5px 20px;
                    text-decoration: none;
                    margin-left: 20px;
                    display: flex;
                    align-items: center;
                    border-radius: 5px;
                    background: #fff;
                  "
                >
                  <img
                    :src="require('../../assets/stripe.svg')"
                    width="60px;"
                  />
                </a>
              </p>
            </div>
            <div>
              <!-- <a target="blank" href="https://www.easypay.pt/">
              <img :src="require('../../assets/easypay.jpg')" style="width: 100px;" />
              </a>-->
            </div>
          </div>
        </v-col>
      </v-row>
    </v-footer>
    <PopUp ref="popUp" :cardItem="cardItem" @ok="onInput" />
  </v-app>
</template>

<script>
import Api from '../../services/httpClient';
import NavbarPublica from '../../components/NavbarPublica.vue';
import PopUp from '../../components/PupUP.vue';
import getLanguage from '../../utils/getLanguage';

export default {
  components: {
    PopUp,
    NavbarPublica,
  },
  data() {
    return {
      testimonials: [],
      email: '',
      radioValue: 'paciente',
      msg: '',
      isAlert: false,
      isType: 'error',
      isLoading: false,
      showFullText: false,
      cardItem: [],
      lang: '',
    };
  },
  created() {
    this.lang = getLanguage(window.location.href);
    Api.get('/testimonials/')
      .then((res) => {
        console.log(res.data);
        this.testimonials = res.data;
      })
      .catch((err) => console.log(err));
  },
  mounted() {
    this.popUp();
  },
  methods: {
    popUp() {
      Api.get('/popups/')
        .then((res) => {
          console.log(res.data);
          const { data } = res;
          this.cardItem = data;
          if (this.cardItem.length === 0 || this.cardItem[0].active === false) {
            return;
          }
          const { popUp } = this.$refs;
          if (!popUp) return;
          popUp.openDialog();
        })
        .catch((err) => console.log(err));
    },
    onMore() {
      this.showFullText = true;
    },
    offMore() {
      this.showFullText = false;
    },
    async signUp() {
      this.isLoading = true;
      try {
        const result = await Api.post('/register_mail/', {
          isPatient: this.radioValue === 'paciente',
          email: this.email,
        });
        if (result.status === 'error') {
          console.log('Deu erro');
        } else {
          this.msg = 'Inscrição efetuada com sucesso!';
          this.isType = 'success';
          this.isAlert = true;
          this.email = '';
          console.log(result);
        }
      } catch (error) {
        console.log(error.response.data.mensagem);
        this.msg = error.response.data.mensagem;
        this.isAlert = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
* >>> .v-carousel {
  box-shadow: none !important;
}

* >>> .v-carousel__controls {
  background: rgba(0, 0, 0, 0) !important;
}

* >>> .v-carousel__controls__item .v-btn__content .v-icon {
  color: #93291e;
}
/* * >>> .v-carousel__controls__item {
  color: var(--v-primary-base) !important;
} */

.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.v-radio div {
  overflow: hidden;
}

.my__toolbar {
  height: auto;
}
.text-2 {
  margin-top: 190px;
}
.white-box {
  margin: 0 auto;
  width: 100px;
  height: 100px;
  border-radius: 8px;
}

.hero-section {
  background: url('../../assets/hero-background2.png');
  background-position-y: top !important;
  /* background-position-x: -34rem ​!important; */
  background-size: 150% !important;
  background-repeat: no-repeat !important;
  background-position: -34rem;
}

.btn-hero-register {
  height: 65px !important;
}

/* .icon-schedule {
  font-size: 6rem !important;
} */

.subtitulo-midia u {
  text-decoration: none;
  border-bottom: 1px solid black;
}

​.hero-text,
.register-title,
.schedule-text,
.media-subtitle {
  font-size: 1.7rem;
}

.news-text,
.opinion-title {
  font-size: 2rem;
}

.subtitle-hero,
.begin-therapy,
.schedule-begin-therapy,
.newstitle,
.therapy-online-title,
.icon-star {
  font-size: 3rem;
}

.trasparent-background {
  width: 100%;
  padding: 10px;
  min-height: 200px;
  background-color: rgba(255, 255, 255, 0.8);
}
.therapy-online-subtitle {
  margin: 20px 0px;
  text-align: left;
}

.therapy-online-title {
  text-align: left;
}

.container-card {
  display: flex;
  justify-content: center;
  background: #fff;
}

.box-card {
  width: 90%;
  max-width: 330px;
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.19);
  border-radius: 10px;
  padding: 10px;
  background: #fff;
  margin-right: 40px;
  margin-bottom: 20px;
}
.box-card:last-child {
  margin-right: 0px !important;
}

.v-input--radio-group {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.cover {
  background-size: cover !important;
}

.section-busca-psy {
  min-height: 350px;
  background: #ffffff77;
}

.subtitle-cards {
  font-size: 17px !important;
}

.search-pisc {
  background: #fff;
  position: relative;
}
.search-pisc > img:first-child {
  width: 460px;
  z-index: 4;
  position: absolute;
  top: 50px;
  left: -250px;
}
.search-pisc > img:last-child {
  width: 460px;
  z-index: 4;
  position: absolute;
  top: 50px;
  right: -250px;
}
.fit-cover {
  object-fit: cover;
}

.s2-box1 {
  background: url(../../assets/girl.png) no-repeat;
}

.s2-box2 {
  background: url(../../assets/office.png) no-repeat;
}

.section-2-box {
  height: 30vh;
}

.section-2-box p {
  font-size: 1.3rem;
}

.minor-text,
.why-text {
  font-size: 1.3rem;
}

.icon-news {
  font-size: 4rem;
}

.contain {
  object-fit: contain;
}

.video-container iframe {
  width: 100%;
  height: 300px;
}

.card-search {
  background-position: center;
}

.section-parceiros {
  background: linear-gradient(#f7f7f7, 3%, #fff);
}

.btn-professionals {
  height: 80px !important;
}

.image-team {
  height: 400px;
}

.image-client {
  border-radius: 50%;
  width: 95px;
  height: 95px;
  margin: 0 auto;
}

.carousel-firstblock h2 {
  text-align: left;
  margin-left: 28px;
}
.title-med {
  font-size: 35px !important;
  font-weight: 400 !important;
}
.white-box-midia {
  height: 100px;
}

.section-midia {
  background-image: url(../../assets/bg_namidia.png),
    url(../../assets/bg_namidia.png);
  background-repeat: repeat-x, repeat-x;
  background-position: 0 top, 0 bottom;
  background-color: #e8fcfd;
  padding-top: 60px;
  padding-bottom: 60px;
}

.more-depoiments {
  background: #f7f7f7;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 20;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  padding: 10px 20px;
  color: #0ea95c;
  font-size: 15px;
  cursor: pointer;
}

.subtitle-main {
  display: block;
  font-size: 20px;
  color: #9f2714;
  width: 100%;
  font-weight: 400;
  max-width: 670px;
  padding: 7px 4px;
  background: #ffffffb0;
  border-radius: 20px;
  text-align: center;
  margin: 0 auto;
}

.button-anchor {
  border-radius: 8px;
  text-transform: uppercase;
  font-weight: 500;
  height: 36px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  text-decoration: none;
  margin: 0px 5px;
}

.depoiment-content {
  width: 100%;
  margin: 28px auto;
}

.subtitle-cards {
  font-size: 20px;
}
.font-size-title-grid {
  font-size: 20px;
}

.font-size-body-grid {
  font-size: 22px;
}

.pseudo-input-busca-psy {
  border-radius: 10px;
  min-height: 70px;
}

.card-cta-red {
  display: flex;
  background-color: #9f2714;
  justify-content: space-between;
  width: 100vw;
  height: 16rem;
  padding: 0;
}
.card-cta-white {
  display: flex;
  justify-content: space-between;
  width: 100vw;
  height: 16rem;
  padding: 0;
  color: #9f2714;
}
.wave {
  max-height: 8rem;
}
.wave:first-child {
  align-self: flex-end;
}
.wave:last-child {
  transform: rotate(180deg);
}
.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
  text-align: center;
  margin: auto;
  width: 80%;
}
.card-content span {
  font-size: 2rem;
  font-weight: 600;
}
.card-button {
  font-size: 1.2rem;
  border-radius: 16px;
  margin-top: 24px;
  padding: 0 8px;
  color: #9f2714;
  max-width: 80%;
  font-weight: 600;
}

.card-cta-white .card-content {
  color: #9f2714;
}
.card-cta-white .card-button {
  background-color: #9f2714;
  color: #ffffff;
}

@media screen and (max-width: 904px) {
  .container-card {
    flex-direction: column;
    justify-content: center !important;
    align-items: center;
  }
  .search-pisc {
    background: #fff;
  }
  .search-pisc > img:first-child {
    display: none;
  }
  .search-pisc > img:last-child {
    display: none;
  }
  .box-card {
    margin-right: 0 !important;
  }

  .card-cta-red,
  .card-cta-white {
    height: 20rem;
    flex-direction: column;
  }
  .card-content span {
    font-size: 1.2rem;
  }
  .wave {
    max-height: 4rem;
  }
  .wave:first-child {
    justify-self: end;
    transform: rotate(180deg);
  }
  .wave:last-child {
    align-self: flex-start;
    transform: none;
  }
  .card-button {
    font-size: 0.6rem;
    max-width: 100%;
  }
}

@media screen and (min-width: 1024px) {
  .opinion-client {
    font-size: 1.3rem;
  }
  .section-2-box {
    height: 50vh;
  }

  * >>> .slick-next:before,
  * >>> .slick-prev:before {
    font-size: 63px;
  }

  * >>> .slick-next {
    right: 55px !important;
  }

  .therapy-online-title {
    line-height: 41px;
  }
}

.v-input__control {
  width: 100% !important;
}
.iframe-youtube {
  margin: auto;
  padding: 2rem 30%;
}
.video-youtube {
  width: 100%;
  height: 24rem;
}
.btn-faq {
  width: 110px;
  height: 35px;
  color: #93291e;
  margin-bottom: 5px;
}
@media screen and (min-width: 760px) {
  .row-carousel-item {
    padding: 0 48px;
  }
}

@media screen and (max-width: 1256px) {
  .therapy-online-title {
    text-align: center !important;
  }
  .therapy-online-subtitle {
    text-align: center !important;
  }
  .hero-section {
    background-size: 200% !important;
  }
}

@media screen and (max-width: 1427px) {
  .hero-section {
    background-size: 190% !important;
  }
}

@media screen and (max-width: 900px) {
  .hero-section {
    background-size: 250% !important;
  }
}

@media screen and (max-width: 770px) {
  .hero-section {
    background-size: 400% !important;
  }
}

@media screen and (max-width: 425px) {
  .hero-section {
    background-position-x: right !important ;
    background-size: 600% !important;
  }
}

@media screen and (max-width: 426px) {
  .parceiro-subtitle {
    width: 100%;
    max-width: 320px;
    margin: 20px auto;
    font-size: 25px !important;
  }
}

@media screen and (max-width: 600px) {
  .text-2 {
    margin-top: 10px;
  }
  .video-container iframe {
    width: 100%;
    height: 200px;
  }
}

@media screen and (max-width: 1256px) {
  .therapy-online-title {
    text-align: center !important;
  }
  .therapy-online-subtitle {
    text-align: center !important;
  }
}

@media screen and (max-width: 426px) {
  .parceiro-subtitle {
    width: 100%;
    max-width: 320px;
    margin: 20px auto;
    font-size: 25px !important;
  }
}

@media screen and (max-width: 600px) {
  .text-2 {
    margin-top: 10px;
  }
  .video-container iframe {
    width: 100%;
    height: 200px;
  }
}
@media screen and (max-width: 420px) {
  * >>> .carousel-entrevistas .v-window__prev,
  * >>> .carousel-entrevistas .v-window__next {
    display: none !important;
  }

  .v-menu--inline {
    display: none !important;
  }
  .disappear-mobile {
    display: none;
  }

  .navbar-buttons {
    font-size: 10px;
    justify-content: start;
    margin: 0;
  }

  .btn-professionals,
  .section-2-box p,
  .why-text {
    font-size: 1rem;
  }

  .section-busca-psy {
    min-height: auto;
    background-size: 0;
  }

  .pseudo-input-busca-psy {
    border-radius: 10px 0 0 10px;
    min-height: 40px;
    .v-icon {
      font-size: 20px !important;
    }
  }

  .opinion-title,
  .begin-therapy-subtitle,
  .schedule-begin-therapy,
  .media-subtitle {
    font-size: 1.2rem;
  }

  .register-title {
    font-size: 2rem;
  }

  .section-2-box {
    height: 60vh;
  }

  .newstitle,
  .begin-therapy {
    font-size: 1.7rem;
  }

  .icon-schedule {
    font-size: 3rem;
  }

  .begin-therapy-subtitle {
    line-height: 19px;
  }

  .therapy-online-title {
    font-size: 2rem;
    font-weight: 200 !important;
  }

  .schedule-text {
    font-size: 0.9rem;
  }

  /* .schedule-text span {
    display: none;

  } */

  .white-box {
    /* margin: 0 10px; */
    height: 70px;
    width: 70px;
  }

  .video-youtube {
    height: 16rem;
  }
  .iframe-youtube {
    margin: auto;
    padding: 2rem;
  }

  .row-carousel-item {
    /* padding: 0; */
  }
}
</style>
